"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerticalView = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@dbi-tools/ui-kit");

var _linkButtons = _interopRequireDefault(require("../../link-buttons"));

var _contentUi = _interopRequireDefault(require("../../content/content-ui"));

var _linkUi = _interopRequireDefault(require("../../link/link-ui"));

var _const = require("../../link/const");

var _photoLayout = require("../photo-layout.styled");

var _const2 = require("../const");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var VerticalView = function VerticalView(_ref) {
  var setRef = _ref.setRef,
      btnColor = _ref.btnColor,
      headline1 = _ref.headline1,
      headline2 = _ref.headline2,
      imageText = _ref.imageText,
      headline1Color = _ref.headline1Color,
      headline2Color = _ref.headline2Color,
      renditionSrc = _ref.renditionSrc,
      _ref$boxPadding = _ref.boxPadding,
      boxPadding = _ref$boxPadding === void 0 ? [60, 0] : _ref$boxPadding,
      hideText = _ref.hideText,
      isMobile = _ref.isMobile,
      isScrollView = _ref.isScrollView,
      link = _ref.link,
      linkTitle = _ref.linkTitle,
      altText = _ref.altText,
      imageLink = _ref.imageLink;
  var isHeaderBlockExist = headline1 || headline2 || imageText;
  var headerRef = (0, _react.useRef)(null);
  var imageRef = (0, _react.useRef)(null);
  var mobileSize = isScrollView ? _const2.MOBILE_SCROLL_SIZE : _const2.MOBILE_CAROUSEL_SIZE;
  var tabletSize = isScrollView ? _const2.TABLET_SCROLL_SIZE : _const2.TABLET_CAROUSEL_SIZE;
  var defaultBLockHeight = isMobile ? mobileSize : tabletSize;

  var _useState = (0, _react.useState)(defaultBLockHeight),
      _useState2 = _slicedToArray(_useState, 2),
      imageHeight = _useState2[0],
      setImageHeight = _useState2[1];

  var updateValues = function updateValues() {
    var current = headerRef.current;
    if (!current) return;

    var _getBoundingClientRec = current.getBoundingClientRect(),
        headerTextHeight = _getBoundingClientRec.height;

    var tempImageHeight = defaultBLockHeight - headerTextHeight;
    setImageHeight(tempImageHeight);
  };

  (0, _react.useEffect)(function () {
    updateValues();
  }, [headerRef]);

  var updateRef = function updateRef() {
    if (setRef) {
      setRef(imageRef);
    }
  };

  return /*#__PURE__*/_react.default.createElement(_photoLayout.VerticalViewStyled, {
    isScrollView: isScrollView
  }, isHeaderBlockExist && !hideText && /*#__PURE__*/_react.default.createElement(_uiKit.Box, {
    ref: headerRef,
    p: boxPadding
  }, headline1 && /*#__PURE__*/_react.default.createElement(_photoLayout.ItemOverlineStyled, {
    as: "h4",
    color: headline1Color,
    align: "center"
  }, headline1), headline2 && /*#__PURE__*/_react.default.createElement(_photoLayout.ItemHeadlineStyled, {
    as: "h4",
    color: headline2Color,
    align: "center"
  }, headline2), imageText &&
  /*#__PURE__*/
  // TODO remove temp solution
  // @ts-ignore
  _react.default.createElement(_photoLayout.ItemDescriptionStyled, {
    as: "div",
    measure: "lg",
    color: headline2Color
  }, /*#__PURE__*/_react.default.createElement(_contentUi.default, null, imageText))), /*#__PURE__*/_react.default.createElement(_photoLayout.ImageWrapperStyled, {
    maxHeight: imageHeight,
    isScrollView: isScrollView
  }, imageLink ? /*#__PURE__*/_react.default.createElement(_linkUi.default, {
    link: imageLink,
    target: (0, _const.linkTarget)(imageLink)
  }, /*#__PURE__*/_react.default.createElement("img", {
    onLoad: updateRef,
    loading: "lazy",
    ref: imageRef,
    src: renditionSrc,
    alt: altText || headline1
  })) : /*#__PURE__*/_react.default.createElement("img", {
    onLoad: updateRef,
    loading: "lazy",
    ref: imageRef,
    src: renditionSrc,
    alt: altText || headline1
  })), linkTitle && link && /*#__PURE__*/_react.default.createElement(_uiKit.Box, {
    display: "flex",
    justifyContent: {
      xs: 'center',
      lg: 'flex-end'
    }
  }, /*#__PURE__*/_react.default.createElement(_linkButtons.default, {
    color: btnColor,
    buttons: [{
      link: link,
      text: linkTitle,
      type: 'link'
    }]
  })));
};

exports.VerticalView = VerticalView;